import HTTP from '@/utils/http-common';
import { encodeOpts } from '@/utils/encode-opts';

const getChecklists = async (query) => (await HTTP.get(`/checklist`, {
  params: query,
  paramsSerializer: encodeOpts
})).data;
const updateChecklist = async (data) => (await HTTP.put(`/checklist/${data._id}`, data)).data;
const createChecklist = async (data) => (await HTTP.post(`/checklist`, data)).data.model;
const deleteChecklist = async (checklist) => (await HTTP.delete(`/checklist/${checklist._id}`)).data;
const saveChecklist = async (data) => !data._id ? (await createChecklist(data)) : (await updateChecklist(data));
const getMyChecklist = async (query) => (await HTTP.get(`/checklist/my`, {
  params: query,
  paramsSerializer: encodeOpts
})).data;
const toggleMyChecklist = async (checklist) => (await HTTP.post(`/checklist/my/${checklist._id}/toggle`, {})).data.model;
const getDistributorChecklist = async (distributorId) => (await HTTP.get(`/checklist/distributors/${distributorId}`)).data;
const updateDistributorChecklist = async (distributor) => (await HTTP.put(`/checklist/distributors/${distributor._id}`, distributor)).data;
const getUserChecklist = async (userId) => (await HTTP.get(`/checklist/users/${userId}`)).data;
const updateUserChecklist = async (user) => (await HTTP.put(`/checklist/users/${user._id}`, user)).data;
const hasNotCompletedInChecklist = async () => {
  try {
    const { data } = await getMyChecklist();
    return data.some(({ isDone }) => !isDone);
  } catch(e) {}
};

export {
  getChecklists,
  updateChecklist,
  createChecklist,
  deleteChecklist,
  saveChecklist,
  getMyChecklist,
  toggleMyChecklist,
  getDistributorChecklist,
  updateDistributorChecklist,
  getUserChecklist,
  updateUserChecklist,
  hasNotCompletedInChecklist
};
